import React, { useEffect, useState } from 'react'
import StateComponents from '../../../../components/state-component/StateComponents'
import { BookingMeetingRoomRequestApi, MeetingAgenda, MeetingRoomFile } from '../../../../api/booking-meeting-room-request/booking-meeting-room-request.api';
import { produce } from 'immer';
// import { validateObject } from '../../../../utils/app.utils';
import { Box, Button, Typography } from '@mui/material';
import UploadFile from '../../../../components/upload/UploadFile';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { useNavigate } from 'react-router-dom';
import { routeName } from '../../../../routes/routeName';
import { alertSuccess } from '../../../../components/alert/swal';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';

type Props = {
    id_meeting_room: number;
    uploadMultiFilePromise: (file: File[]) => Promise<any[]>;
    handleDownloadFile: (id_meeting_room_file: number, file_name: string) => void;
    view?: boolean;
}

const CalendarActivityDetail: React.FC<Props> = ({ view, id_meeting_room, handleDownloadFile, uploadMultiFilePromise }: Props) => {
    const navigate = useNavigate();

    const dispatch = useDispatch();
    const [dataDetail, setDataDetail] = useState<any>(null);
    const [id_meeting_agenda, set_id_meeting_agenda] = useState<number | null>(null);

    const [activity_file, set_activity_file] = useState<any>(null);
    const [formState, setFormState] = useState<MeetingAgenda>({
        file_cover: {
            file_name: "",
            file_path: "",
            file_size: "",
            file_type: "",
            id_meeting_room_file: null
        },
        event_organizer: "",
        participant_type: "",
        file_information_calendar: [],
        id_meeting_room,
        meeting_agenda_desc: "",
        meeting_agenda_name: "",
        meeting_agenda_resolution: "",
        meeting_room_link: "",
    })
    const [files, set_files] = useState<{ file: any }[]>([
        {
            file: null
        }
    ]);

    const handleChange = <K extends keyof MeetingAgenda>(
        field: K,
        value: MeetingAgenda[K]
    ) => {
        setFormState(prev =>
            produce(prev, draft => {
                draft[field] = value;
            })
        );
    };

    const handleAddFile = () => {
        const new_file = {
            file: null
        }
        set_files((prev) => produce(prev, (draft) => {
            draft.push(new_file);
        }))
    }
    const handleChangeFile = (index: number, new_file: any) => {
        set_files(prev =>
            produce(prev, draft => {
                if (draft[index]) {
                    draft[index].file = new_file;
                }
            })
        );
    };
    const handleDeleteRow = (index: number) => {
        set_files((prev) => prev.filter((_, i) => i !== index))
    }
    const handleDeleteFile = (index: number) => {
        set_files((prev) => produce(prev, (draft) => {
            if (draft[index]) {
                draft[index].file = null
            }
        }))
    }


    const handleGetCalendarInformationData = async () => {
        await BookingMeetingRoomRequestApi.findOneInformationCalendar(id_meeting_room).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data || null;
                setDataDetail(response);
            }
        }).catch((err) => {
            console.log(err)
        })
    }


    // const check_error_field = validateObject<MeetingAgenda>(formState, {
    //     exclude: ['file_cover', 'file_information_calendar', 'id_meeting_room'],
    //     customMessage: {
    //         meeting_agenda_resolution: "",
    //         meeting_agenda_desc: "",
    //         meeting_agenda_name: "",
    //         meeting_room_link: "",
    //     }
    // })
    const handleUploadFile = async (files_value: { file: File | null }[]): Promise<MeetingRoomFile[]> => {
        if (files_value?.length > 0) {
            const file_data = files_value?.flatMap((list) => list?.file) as File[];
            const id_file = await uploadMultiFilePromise(file_data);
            if (id_file?.length > 0) {
                return id_file?.map((list) => {
                    const file = list?.file;
                    return {
                        file_name: file?.file_name,
                        file_path: file?.file_path,
                        file_size: file?.file_size,
                        file_type: file?.file_type,
                        id_meeting_room_file: file?.id_meeting_room_file
                    }
                })
            } else {
                return []
            }
        } else {
            return []
        }
    }



    const generateForm = async (): Promise<MeetingAgenda> => {
        let id_file_information_calendar: MeetingRoomFile[] = [];
        let file_cover: MeetingRoomFile | null = null;
        if (files?.length > 0) {
            id_file_information_calendar = await handleUploadFile(files.filter((x) => !x?.file?.id_meeting_room_file));
        }
        if (files?.length > 0 && files?.some((x) => x?.file?.id_meeting_room_file)) {
            id_file_information_calendar.push(...files?.filter((x) => x?.file?.id_meeting_room_file)?.map((list) => {
                return {
                    file_name: list?.file?.file_name,
                    file_path: list?.file?.file_path,
                    file_size: list?.file?.file_size,
                    file_type: list?.file?.file_type,
                    id_meeting_room_file: list?.file?.id_meeting_room_file
                }
            }))
        }
        if (activity_file && !activity_file?.id_meeting_room_file) {
            file_cover = await handleUploadFile([{ file: activity_file }]).then((val) => val[0]);
        }
        if (activity_file?.id_meeting_room_file) {
            file_cover = {
                file_name: activity_file?.file_name,
                file_path: activity_file?.file_path,
                file_size: activity_file?.file_size,
                file_type: activity_file?.file_type,
                id_meeting_room_file: activity_file?.id_meeting_room_file
            }
        }
        return {
            file_cover: file_cover,
            file_information_calendar: id_file_information_calendar,
            id_meeting_room,
            event_organizer: formState.event_organizer,
            meeting_agenda_desc: formState.meeting_agenda_desc,
            meeting_agenda_name: formState.meeting_agenda_desc,
            meeting_agenda_resolution: formState.meeting_agenda_resolution,
            meeting_room_link: formState.meeting_room_link,
            participant_type: formState.participant_type,
        }
    }

    const handleSubmit = async () => {
        const body = await generateForm();
        dispatch(setLoading());
        if (id_meeting_agenda) {
            await BookingMeetingRoomRequestApi.updateInformationCalendar(id_meeting_agenda, body).then((res) => {
                if (res.status < 300) {
                    handleGetData();
                    alertSuccess("อัพเดตข้อมูลในปฏิทินกิจกรรม", 'อัพเดตข้อมูลในปฏิทินกิจกรรม เรียบร้อยแล้ว');
                }
            }).catch((err) => {
                console.log(err)
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } else {
            await BookingMeetingRoomRequestApi.createInformationCalendar(body).then((res) => {
                if (res.status < 300) {
                    handleGetData();
                    alertSuccess("เพิ่มข้อมูลในปฏิทินกิจกรรม", 'เพิ่มข้อมูลในปฏิทินกิจกรรม เรียบร้อยแล้ว');
                }
            }).catch((err) => {
                console.log(err)
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
    }


    const handleGetData = async () => {
        dispatch(setLoading());
        await BookingMeetingRoomRequestApi.findOneInformationCalendar(id_meeting_room).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data || null;
                const meeting_room_agenda = response?.meeting_room_agenda || null;
                const file_information_calendar: any[] = response?.file_information_calendar || [];
                const file_cover = response?.file_cover || null;
                if (file_cover) {
                    set_activity_file(file_cover);
                }
                if (file_information_calendar?.length > 0) {
                    set_files(file_information_calendar?.map((list) => ({ file: list })));
                }

                if (meeting_room_agenda?.id_meeting_agenda) {
                    set_id_meeting_agenda(meeting_room_agenda?.id_meeting_agenda);
                }
                setFormState((prev) => ({
                    ...prev,
                    event_organizer: meeting_room_agenda?.event_organizer || "",
                    meeting_agenda_desc: meeting_room_agenda?.meeting_agenda_desc || "",
                    meeting_agenda_name: meeting_room_agenda?.meeting_agenda_name || "",
                    participant_type: meeting_room_agenda?.participant_type || "",
                    meeting_agenda_resolution: meeting_room_agenda?.meeting_agenda_resolution || "",
                    meeting_room_link: response?.meeting_room_link || "",
                }))
                // console.log(response, 'res')
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }


    useEffect(() => {
        handleGetData();
    }, [])
    useEffect(() => {
        handleGetCalendarInformationData();
    }, [])

    return (
        <div>
            <StateComponents
                otherProps={{ spacing: 2 }}
                disabledAllField={view}
                typeProps={[
                    {
                        seq: 1,
                        gridProps: {
                            xs: 12,
                            md: 6,
                            xl: 3
                        },
                        type: "DATE",
                        fieldProps: {
                            disabled: true,
                            heading: "วันที่เริ่มต้น",
                            placeholder: "ระบุ",
                            onChange: () => { },
                            value: dataDetail?.meeting_room_start_date || ""
                        }
                    },
                    {
                        seq: 2,
                        gridProps: {
                            xs: 12,
                            md: 6,
                            xl: 3
                        },
                        type: "DATE",
                        fieldProps: {
                            disabled: true,
                            heading: "วันที่สิ้นสุด",
                            placeholder: "ระบุ",
                            onChange: () => { },
                            value: dataDetail?.meeting_room_end_date || ""
                        }
                    },
                    {
                        seq: 3,
                        gridProps: {
                            xs: 12,
                            md: 6,
                            xl: 3
                        },
                        type: "TIME_PICKER",
                        fieldProps: {
                            disabled: true,
                            placeholder: "ระบุ",
                            heading: "เวลาเริ่มต้น",
                            onChange: () => { },
                            value: dataDetail?.meeting_room_start_time || ""
                        }
                    },
                    {
                        seq: 4,
                        gridProps: {
                            xs: 12,
                            md: 6,
                            xl: 3
                        },
                        type: "TIME_PICKER",
                        fieldProps: {
                            disabled: true,
                            heading: "เวลาสิ้นสุด",
                            onChange: () => { },
                            placeholder: "ระบุ",
                            value: dataDetail?.meeting_room_end_time || ""
                        }
                    },
                    {
                        seq: 5,
                        gridProps: {
                            xs: 12,
                            md: 6,
                            xl: 6
                        },
                        type: "TEXT_FIELD",
                        fieldProps: {
                            heading: "ประเภทผู้เข้าร่วม",
                            placeholder: "ระบุ",
                            onChange: (e) => handleChange('participant_type', e.target.value),
                            value: formState.participant_type
                        }
                    },
                    {
                        seq: 6,
                        gridProps: {
                            xs: 12,
                            md: 6,
                            xl: 6
                        },
                        type: "TEXT_FIELD",
                        fieldProps: {
                            heading: "ผู้จัดงาน",
                            placeholder: "ระบุ",
                            onChange: (e) => handleChange('event_organizer', e.target.value),
                            value: formState.event_organizer
                        }
                    },
                    {
                        seq: 7,
                        gridProps: {
                            xs: 12,
                            md: 12,
                            xl: 12
                        },
                        type: "TEXT_FIELD",
                        fieldProps: {
                            placeholder: "ระบุ",
                            heading: "ชื่อเรื่อง",
                            onChange: (e) => handleChange('meeting_agenda_name', e.target.value),
                            value: formState.meeting_agenda_name
                        }
                    },
                    {
                        seq: 8,
                        gridProps: {
                            xs: 12,
                            md: 12,
                            xl: 12
                        },
                        type: "TEXT_FIELD",
                        fieldProps: {
                            heading: "รายละเอียด",
                            row: 3,
                            maxRows: 3,
                            inputHeight: "auto",
                            placeholder: "ระบุ",
                            disablePaddingMultiline: true,
                            multiline: true,
                            maxLength: 300,
                            enableCountMaxLength: true,
                            onChange: (e) => handleChange('meeting_agenda_desc', e.target.value),
                            value: formState.meeting_agenda_desc
                        }
                    },
                    {
                        seq: 9,
                        gridProps: {
                            xs: 12,
                            md: 12,
                            xl: 12
                        },
                        type: "TEXT_FIELD",
                        fieldProps: {
                            heading: "ช่องทางติดต่อ",
                            row: 3,
                            maxRows: 3,
                            placeholder: "ระบุ",
                            inputHeight: "auto",
                            disablePaddingMultiline: true,
                            multiline: true,
                            maxLength: 300,
                            enableCountMaxLength: true,
                            onChange: (e) => handleChange('meeting_agenda_resolution', e.target.value),
                            value: formState.meeting_agenda_resolution
                        }
                    },
                    {
                        seq: 10,
                        gridProps: {
                            xs: 12,
                        },
                        type: "TEXT_FIELD",
                        fieldProps: {
                            placeholder: "ระบุ",
                            heading: "ลิ้งค์",
                            onChange: (e) => handleChange('meeting_room_link', e.target.value),
                            value: formState.meeting_room_link
                        }
                    },
                    {
                        seq: 11,
                        gridProps: {
                            xs: 12,
                            md: 12,
                            xl: 12
                        },
                        type: "UPLOAD-FILE",
                        fieldProps: {
                            noClick: !!activity_file || !!activity_file?.id_meeting_room_file || view,
                            heading: "ไฟล์ภาพปกกิจกรรม (ขนาดที่แนะนำ 1920x700 px)",
                            onDrop: (file) => set_activity_file(file),
                            onDeleteFileId: view ? undefined : () => set_activity_file(null),
                            fileAttachmentId: activity_file?.id_meeting_room_file,
                            fileAttachmentName: activity_file?.file_name,
                            onDeleteFile: view ? undefined : () => set_activity_file(null),
                            enableFormatImage: true,
                            file: activity_file
                        }
                    },
                ]}
            />

            <Box mt={2}>
                <Box className="flex justify-start items-center gap-5">
                    <Typography>
                        ไฟล์แนบอื่นๆ
                    </Typography>
                    {!view && (
                        <Button onClick={handleAddFile} startIcon={<AddCircleOutlineOutlinedIcon />} color='success'>
                            เพิ่ม
                        </Button>
                    )}
                </Box>
                <Box className="w-full flex flex-col gap-4">
                    {files?.map((list, i) => {
                        return (
                            <UploadFile
                                onDrop={(nf) => {
                                    handleChangeFile(i, nf)
                                }}
                                fileAttachmentId={list?.file?.id_meeting_room_file || undefined}
                                fileAttachmentName={list.file?.file_name || undefined}
                                onDeleteFileId={view ? undefined : () => {
                                    handleDeleteFile(i);
                                }}
                                onDownloadFile={() => {
                                    list?.file?.id_meeting_room_file && handleDownloadFile(list?.file?.id_meeting_room_file, list.file?.file_name)
                                }}
                                customHeading={
                                    i !== 0 && !view &&
                                    <Button onClick={() => handleDeleteRow(i)} startIcon={<ClearOutlinedIcon />} sx={{ my: 1 }} variant='outlined' color='error'>
                                        ลบแถว
                                    </Button>
                                }
                                noClick={!!list?.file?.id_meeting_room_file || !!list?.file || view}
                                file={list?.file || null}
                                onDeleteFile={view ? undefined : () => {
                                    handleDeleteFile(i);
                                }}
                            />
                        )
                    })}
                </Box>
            </Box>


            {!view && (
                <Box my={2} className="flex justify-center items-center gap-4">
                    <Button onClick={() => navigate(routeName.cms.BookingRoomRequestMangement)} variant='outlined'>ยกเลิก</Button>
                    <Button onClick={() => handleSubmit()} color='success' variant='contained'>ยืนยัน</Button>
                </Box>
            )}
        </div>
    )
}

export default CalendarActivityDetail